export class ResponseStatus {
  public static COMPLETED = 'COMPLETED';
  public static QUEUED = 'QUEUED';
  public static IN_PROGRESS = 'IN-PROGRESS';
  public static FAILED = 'FAILED';
  public static VALIDATION_ERROR = 'VALIDATION-ERROR';
  public static TAX_ERROR = 'TAX_ERROR';
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/response-status-constants.ts